import {
  CONTENT_WIDTH,
  bottomMarginItemGlobal
} from "../../utils/pdfConstants";

export function renderPohjavesiBlock({
  contentWidth = CONTENT_WIDTH,
  content = [],
  rakennusData,
  fontSize = 10
} = {}) {
  if (!content) throw new Error("content is required");

  const buildings = rakennusData?.rakennukset_fulls || [];
  const smallFontSize = fontSize * 0.85;

  const GREEN = "#04aa00";
  const LIGHT_GREY = "#f0f0f0";
  const WHITE = "#ffffff";

  const renderCellValue = value => {
    if (value === null || value === undefined || value === "") {
      return "–";
    }
    return String(value);
  };

  const createCell = (
    text,
    {
      bold = false,
      color = "black",
      fillColor,
      alignment = "left"
    } = {}
  ) => ({
    text: renderCellValue(text),
    bold,
    color,
    fillColor,
    alignment,
    font: "Lato",
    fontSize: smallFontSize
  });

  const createTableLayout = () => ({
    hLineWidth: () => 0,
    vLineWidth: () => 0,
    paddingLeft: () => 4,
    paddingRight: () => 4,
    paddingTop: () => 4,
    paddingBottom: () => 4,
    dontBreakRows: false
  });

  const allPohjavesi = buildings.flatMap(
    building => building.aluetiedot?.pohjavesi || []
  );

  const uniquePohjavesi = [];
  const seenPohjavesi = new Set();

  allPohjavesi.forEach(item => {
    const key = [
      item.nimi || "",
      item.luokka || "",
      item.etäisyys || ""
    ].join("|");

    if (!seenPohjavesi.has(key)) {
      seenPohjavesi.add(key);
      uniquePohjavesi.push(item);
    }
  });

  const body = [
    [
      {
        ...createCell("Pohjavesialueet", {
          bold: true,
          color: WHITE,
          fillColor: GREEN
        }),
        colSpan: 2
      },
      {}
    ]
  ];

  if (uniquePohjavesi.length === 0) {
    body.push([
      {
        ...createCell("Kohde ei sijaitse pohjavesialueella."),
        colSpan: 2
      },
      {}
    ]);
  } else {
    uniquePohjavesi.forEach((item, index) => {
      if (uniquePohjavesi.length > 1) {
        body.push([
          {
            ...createCell(`Pohjavesialue ${index + 1}`, {
              bold: true,
              fillColor: LIGHT_GREY
            }),
            colSpan: 2
          },
          {}
        ]);
      }

      body.push([
        createCell("Nimi"),
        createCell(item.nimi)
      ]);

      if (item.luokka) {
        body.push([
          createCell("Luokka"),
          createCell(item.luokka)
        ]);
      }

      if (item.etäisyys) {
        body.push([
          createCell("Etäisyys"),
          createCell(item.etäisyys)
        ]);
      }
    });
  }

  const TABLE_WIDTH = contentWidth * 0.92;

  content.push({
    table: {
      widths: [
        TABLE_WIDTH * 0.47,
        TABLE_WIDTH * 0.58
      ],
      body
    },
    layout: createTableLayout(),
    margin: [
  0,
  0,
  0,
  bottomMarginItemGlobal
]
  });
}